export default __webpack_public_path__ + "static/media/location.67a89daa.png";